const ExportStatusEnum = {
  NOT_EXPORT: 1,
  IN_EXPORT: 2,
  POST_EXPORT: 3
}
export default ExportStatusEnum


// WEBPACK FOOTER //
// ./src/enum/exportStatusEnum.js